import { ApiError } from "@/core/api/types";

export const onboardingKey = (businessId?: string | null) =>
  ["business-onboarding", businessId] as const;

export const onboardingPath = (businessId: string) =>
  `/businesses/${businessId}/onboarding`;

export const isOnboardingConflict = (error: unknown) =>
  error instanceof ApiError && error.status === 409;

// Download paths include /api. Resolve them against the backend origin, rather
// than the Web origin or the API base path (which would add /api twice).
export const invoiceSampleDownloadUrl = (path: string, apiBase: string) => {
  const base = new URL(apiBase);
  const url = new URL(path, base.origin);
  if (url.origin !== base.origin)
    throw new Error("Invalid sample download URL");
  return url.href;
};
